const breakpointXS = 480;

export { breakpointXS };
